import { IconContent } from '@icons';

export const pinFilled: IconContent = {
    md: '<path d="M14.168 2.89a.5.5 0 1 0-.708.706l1.338 1.338-3.478 3.478-3.754.536a4.876 4.876 0 0 0-2.758 1.379l3.86 3.86-4.98 4.98.708.707 4.98-4.98 3.86 3.86a4.875 4.875 0 0 0 1.378-2.758l.536-3.754 3.478-3.478 1.332 1.332a.5.5 0 0 0 .707-.707l-6.5-6.5Z" />',
};
